
export class ObjectTypeId {

    constructor(private _objectType: string, private _objectId: number) {
    }

    public getUniqueId(): string {
        return ObjectTypeId.getUniqueIdStatic(this);
    }

    public static getUniqueIdStatic(objectTypeId: ObjectTypeId) : string {

        if (objectTypeId.objectId) {
            return objectTypeId.objectType + ":" + objectTypeId.objectId;
        } else {
            return objectTypeId.objectType + ":" + 0;
        }

    }

    get objectType(): string {
        return this._objectType;
    }

    set objectType(value: string) {
        this._objectType = value;
    }

    get objectId(): number {
        return this._objectId;
    }

    set objectId(value: number) {
        this._objectId = value;
    }
}
